export const STORE_MOBILE_MENU = 'mobileMenu';
export const STORE_FILTER_MENU = 'filterMenu';
export const STORE_SF_LOADING = 'sfLoading';
export const STORE_SF_RESULTS_COUNT = 'sfResultsCount';

